import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "../../ppui";
import {
  ContentHeading,
  ContentLayout,
  ContentWrapper,
  ContentMenu,
  ContentForm,
} from "../style";
import { Outlet } from "react-router-dom";
import { List, ListIcon, ListItem, ListText } from "../../ppui/list";
import { RiExchangeFundsLine, RiProfileLine } from "react-icons/ri";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { MdOutlineDocumentScanner } from "react-icons/md";
import { LuUserSquare2 } from "react-icons/lu";
import { GrCompliance } from "react-icons/gr";

function StatutoryComponents() {
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = [
    {
      icon: <RiProfileLine />,
      primaryText: "EPF",
      path: "/statutory",
    },
    {
      icon: <LuUserSquare2 />,
      primaryText: "ESI",
      path: "/statutory/esi",
    },
    {
      icon: <HiOutlineOfficeBuilding />,
      primaryText: "Gratuity ACT",
      path: "/statutory/gratuity",
    },
    {
      icon: <MdOutlineDocumentScanner />,
      primaryText: "P-Tax Status ",
      path: "/statutory/ptax",
    },
    {
      icon: <RiExchangeFundsLine />,
      primaryText: "Labour Welfare Fund ",
      path: "/statutory/labourwelfare",
    },
    {
      icon: <GrCompliance />,
      primaryText: "Compliance Information ",
      path: "/statutory/compliance",
    },
   
  ];

  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Statutory Components
          </Typography>
        </ContentHeading>
        
        <ContentWrapper>
          <ContentMenu>
            <List
              size={"md"}
              color={"default"}
              activeColor={"default"}
              Colorvariant={"dark"}
              hover={"secondary"}
              gap={15}
            >
              {menuItems.map((item, index) => (
                <ListItem
                  key={index}
                  onClick={() => navigate(item.path)}
                  isActive={location.pathname === item.path} // Set isActive to true if paths match
                  colorVariant="light"
                  className={location.pathname === item.path ? "active" : ""}
                >
                  <ListIcon>{item.icon}</ListIcon>
                  <ListText primary={item.primaryText} />
                </ListItem>
              ))}
            </List>
          </ContentMenu>
          <ContentForm>
            <Outlet />
          </ContentForm>
        </ContentWrapper>
      </ContentLayout>
    </>
  );
}

export default StatutoryComponents;
